<template>
  <Popper id="radish-popper" :visible.sync="popperVisible" :target-id="popperTarget">
    <div class="radish-pop">
      <div>
        {{ name }}的任职经历:
        <div class="radish-btn-text" @click="addComExp">增加</div>
      </div>
      <div class="exp-item" v-for="(ce, k) in comExp" :key="k">
        <el-date-picker
          v-model="ce['起始时间']"
          size="mini"
          type="month"
          format="yyyy.MM"
          placeholder="起始时间"
          style="width:110px"
        ></el-date-picker>
        <el-date-picker
          v-model="ce['结束时间']"
          size="mini"
          type="month"
          format="yyyy.MM"
          placeholder="结束时间"
          style="width:110px"
        ></el-date-picker>
        <el-input size="mini" v-model="ce['公司']" placeholder="公司" :title="ce['公司']" style="width:150px" />
        <el-input size="mini" v-model="ce['部门']" placeholder="部门" :title="ce['部门']" style="width:100px" />
        <el-input
          size="mini"
          v-model="ce['目前职位']"
          placeholder="目前职位"
          :title="ce['目前职位']"
          style="width:100px"
        />
        <el-input size="mini" v-model="ce['行业']" placeholder="行业" :title="ce['行业']" style="width:100px" />
        <div class="radish-btn-text" @click="delComExp(k)">删除</div>
      </div>
      <div style="text-align:right;padding-top:5px;">
        <div class="radish-btn" @click="saveComExp">保存</div>
        <div class="radish-btn" @click="popperVisible = false">关闭</div>
      </div>
    </div>
  </Popper>
</template>
<script>
import { Popper } from '../../../project'
const dateFormat = require('dateformat')

export default {
  components: { Popper },
  data: function() {
    return {
      popperVisible: false,
      popperTarget: '',
      comExp: [],
      radishId: '',
      experience: [],
      name: '',
    }
  },
  methods: {
    open(item) {
      this.radishId = item.radishId
      this.experience = item.任职经历
      this.name = item.姓名
      this.showExp()
    },
    async showExp() {
      const res = await app.service('radish').simpleFetch({ _id: this.radishId })
      if (res.status == 'fail') {
        this.$message.error(res.msg)
        return
      } else if (res.msg == 'nothave') {
        this.$message.warning('人选不存在')
        return
      }
      if (this.experience && this.experience.length > 0) {
        this.comExp = this.experience.sort((a, b) => {
          return a['起始时间'] < b['起始时间'] ? 1 : -1
        })
        this.popperVisible = true
        this.popperTarget = `任职经历${this.radishId}`
      } else {
        this.comExp = []
        this.$message.info('无任职经历')
      }
    },
    addComExp() {
      this.comExp.unshift({})
    },
    delComExp(key) {
      this.comExp.splice(key, 1)
    },
    async saveComExp() {
      let exp = this.comExp.map(e => {
        if (e['起始时间'] instanceof Date) {
          e['起始时间'] = dateFormat(e['起始时间'], 'yyyy.mm')
        }
        if (e['结束时间'] instanceof Date) {
          e['结束时间'] = dateFormat(e['结束时间'], 'yyyy.mm')
        }
        return e
      })
      const res = await app.service('radish').modifyRenzhi({
        _id: this.radishId,
        exp,
      })
      if (res.status == 'success') {
        this.$message.success({ duration: 500, message: '修改成功' })
        this.popperVisible = false
      } else {
        this.$message.error(res.msg)
      }
    },
  },
}
</script>
